














import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import CompanyCardBasicData from "./CompanyCardBasicData.vue";
import CompanyCardRates from "./CompanyCardRates.vue";
import CompanyCardContactAddress from "./CompanyCardContactAddress.vue";
import CompanyCardBillingAddress from "./CompanyCardBillingAddress.vue";
import CompanyCardAdditionalInfos from "./CompanyCardAdditionalInfos.vue";
import CompanyCardSettings from "./CompanyCardSettings.vue";
import CardBlamable from "../CardBlamable.vue";
import Company from "../../models/company/Company";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {
		CardBlamable,
		CompanyCardSettings,
		CompanyCardAdditionalInfos,
		CompanyCardBillingAddress,
		CompanyCardContactAddress, CompanyCardRates, CompanyCardBasicData, AsiContentContainer
	}
})
export default class CompanyTabDetails extends Vue {

	@Prop({type: Object, required: true})
	public company!: Company;

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isCheckReports(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCheckReports);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	@Emit('companyChanged')
	public companyChanged(event: Event): Event {
		return event;
	}

}
